<div ngbDropdown placement="bottom" autoClose="outside" class="kt-header__topbar-item">
	<div ngbDropdownToggle class="kt-header__topbar-wrapper" *ngIf="showTopbarTrigger">
		<span class="kt-header__topbar-icon" [ngClass]="{'kt-pulse kt-pulse--brand': pulse, 'kt-pulse--light' : pulseLight,
		'kt-header__topbar-icon--success' : iconType === 'success'	}">
			<!-- Asset URL (e.g. SVG from theme header) vs Flaticon / CSS class name -->
			<img *ngIf="isIconAssetUrl(icon)" [src]="icon" alt="" class="kt-notification-topbar-icon-img" />
			<i *ngIf="!isIconAssetUrl(icon)" [ngClass]="icon" class="kt-topbar-flaticon" [class.text-success]="iconType === 'success'" aria-hidden="true"></i>

			<span class="kt-pulse__ring" [hidden]="!pulse"></span>
		</span>
		<!--span class="kt-badge kt-badge--dot kt-badge--notify kt-badge--sm kt-badge--brand" [hidden]="!dot"></span-->
		<span class="kt-badge kt-badge--unified-danger kt-badge--bold kt-badge--notify" >{{notificationQtys}}</span>


	</div>


	<div ngbDropdownMenu class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-lg">
		<form>
			<!--begin: Head -->
			<div class="kt-head kt-head--skin-{{skin}} kt-head--fit-x kt-head--fit-b" [ngStyle]="{'background-image': backGroundStyle() }">
				<h3 class="kt-head__title" style="color: #FFF !important">
					Portal Notifications&nbsp;
					<span class="btn btn-sm btn-bold btn-font-md notificationbutton" >{{notificationQtys}} new</span>
				</h3>
				<ul ktTabClickEvent class="nav nav-tabs nav-tabs-line nav-tabs-bold nav-tabs-line-3x nav-tabs-line-{{ type }} kt-notification-item-padding-x" role="tablist">
					<li class="nav-item">
						<a (click)="nav.select('1')" class="nav-link active show" data-toggle="nav" href="javascript:;" role="nav" aria-selected="true">EDI Messages</a>
					</li>
					<!--li class="nav-item">
						<a (click)="tab.select('tab-id-2')" class="nav-link" data-toggle="tab" href="javascript:;" role="tab" aria-selected="false">Other Messages</a>
					</li-->

				</ul>



			</div>
			<div>
				<ng-container >
					<ng-scrollbar [ngStyle]="{'max-height': '40vh', 'position': 'relative'}" class="kt-notification kt-margin-t-10 kt-margin-b-10">
						<ng-container *ngFor="let element of notificationList">
							<a href="javascript:void(0);" class="kt-notification__item" (click)="openNotificationDetails(element)">
								<div class="kt-notification__item-icon" >
									<ng-container *ngIf="element.documentType == 'Text Message'">
									<i class="flaticon-feed kt-font-brand" aria-hidden="true"></i>
									</ng-container>
									<ng-container *ngIf="element.documentType == 'Application Advice'">
										<i class="flaticon2-website kt-font-brand" aria-hidden="true"></i>
										</ng-container>
								</div>
								<div class="kt-notification__item-details">
									<div class="kt-notification__item-title">
										{{element.customerNumber}}
									</div>
									<div class="kt-notification__item-time">
										{{element.documentType}} : {{element.documentId}}
									</div>
								</div>
							</a>
						</ng-container>
					</ng-scrollbar>
				</ng-container>
			</div>
			<!--end: Head -->

			<ul  ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">



				<!--ngb-tab id="tab-id-2">
					<ng-template ngbTabContent>
						<div class="kt-grid kt-grid--ver" style="min-height: 200px;">
							<div class="kt-grid kt-grid--hor kt-grid__item kt-grid__item--fluid kt-grid__item--middle">
								<div class="kt-grid__item kt-grid__item--middle kt-align-center">
									All caught up!
									<br>No new notifications.
								</div>
							</div>
						</div>
					</ng-template>
				</ngb-tab-->
			</ul>
		</form>
	</div>
</div>
